import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useInvestmentCustodialLogic } from './hooks/useInvestmentCustodialLogic';
import { InvestmentCustodialForm } from './InvestmentCustodialForm';

export const EddInvestmentCustodial = () => {
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useInvestmentCustodialLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={tCommon('sectionTitles.businessActivity')}
        headingContainerCustomStyle='!mb-[16px]'>
        <InvestmentCustodialForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
